module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesLuxury.c13e1d1.webp";